<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18ShVo/Images/cover.jpg?1706480827415" alt="This image is the cover for the book Gourmet Detective, The Gourmet Detective Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gourmet Detective, The Gourmet Detective Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>From sourcing rare ingredients to solving crimes, “this appealing detective serves up nuggets of culinary trivia and wry food humor” (<i>People</i>).</b><br/>  They call him the gourmet detective; the only thing sharper than his mind is his palate. When chefs need a rare ingredient, an ancient wine, or simply a new idea to gain that extra Michelin-star boost, they come to the detective’s cozy London office and plead for his help. For top-notch cooking, he is always happy to lend his taste buds to the cause. Now Raymond Lefebvre, executive chef at one of London’s finest French restaurants, has asked for the detective’s help with a bit of kitchen espionage. Lefebvre’s crosstown rival is winning international accolades cooking a dish called Oiseau Royal, and Lefebvre wants the recipe. Getting it takes the detective deep into the Circle of Careme, where the most elite chefs in Britain gather to swap recipes, techniques, and gossip. But when the chefs of Careme start to die, the detective starts to salivate. There is no finer appetizer than murder.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter King
      </h2>
      
      <p class="authorDescription body article">Peter King (b. 1922) is an English author of mystery fiction, a Cordon Bleu&ndash;trained chef, and a retired metallurgist. He has operated a tungsten mine, overseen the establishment of South America&rsquo;s first steel processing plant, and prospected for minerals around the globe. His work carried him from continent to continent before he finally settled in Florida, where he led the design team for the rocket engines that carried the Apollo astronauts to the moon.&#160;In his spare time, King wrote one-act plays and short mystery stories. When he retired, in 1991, he wrote his first novel, <i>The Gourmet Detective</i>, a cozy mystery about a chef turned sleuth who solves mysteries in the kitchen. King followed it with seven more books starring the character, including <i>Dying on the Vine </i>(1998) and <i>Roux the Day</i> (2002). In 2001 he published <i>Jewel of the North</i>, the first of three historical mysteries starring Jack London. King lives in Sarasota, Florida.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cb42260